export enum ClassType {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    SUCCESS = 'success',
    WARNING = 'warning',
    INFO = 'info',
    DANGER = 'danger',
    DARK = 'dark',
    LIGHT = 'light'
}
